import React, { useEffect } from "react"

export interface HeadProps {
  children?: React.ReactNode
  title?: string
}

export const Head: React.FC<HeadProps> = ({ children, title }) => {
  useEffect(() => {
    if (title) {
      document.title = title
    }
  }, [title])

  return null
}

export default Head
